"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PetDog = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PetDog = function PetDog(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.52 32.892v-.251l1.06-3.436A9.078 9.078 0 018.838 30.5c.166 1.85.59 3.5.59 3.5h2.258c.893-.823-1.167-1.108-1.167-1.108zm12.736 0v-5.777c-.713.044-1.655.09-2.655.107.285 3.813 1.565 6.778 1.565 6.778h2.258c.893-.823-1.168-1.108-1.168-1.108zM34.717 14.08c-.126.297-1.01 1.616-1.01 1.616l-4.047.139s0 3.927-.567 6.08c-.566 2.152-1.914 4.307-1.914 4.307v6.671s2.061.285 1.168 1.108H26.09s-1.552-3.582-1.622-7.94c0 0-5.256.46-7.918 0-2.663-.458-2.756-.265-3.45.437-.695.701-2.13 2.759-5.604 3.316l-.748 2.828v.252s2.06.284 1.168 1.107h-2.26s-.707-2.747-.653-5.128c0-.138.005-.271.015-.39 0 0 1.227-1.743 1.69-2.203 0 0-.273-4.683 1.87-7.004-1.798-3.474-.595-7.583-.595-7.583.584 4.128 1.559 5.847 2.149 6.537 3.518-1.362 9.354.17 12.566-2.996C26.011 11.969 26.578 6 26.578 6s1.767.956 1.578 2.473c0 0 3.943 2.21 3.849 3.198 0 0 1.671.595 2.523.99.852.396.315 1.12.19 1.418z",
    fill: "#97BA1E"
  }));
};

exports.PetDog = PetDog;
var _default = PetDog;
exports.default = _default;